import React from 'react';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { Card } from 'react-bootstrap';
import './Product.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const Product = ({ product, handleAddToCart }) => {

    const { img, name, price } = product;

    return (

        <div className='col-12 mt-4'>
            <Card style={{ width: '18rem' }}>
                <div className='row d-flex align-items-center'>
                    <div className="col-md-12">
                        <Card.Img variant="top" src={img} />
                    </div>
                    <div className='col-md-12 mt-3'>
                        <Card.Subtitle className="mb-3 text-dark">{name}</Card.Subtitle>
                        <Card.Text>  Price: {price}    </Card.Text>

                        <button onClick={() => handleAddToCart(product)} style={{ width: '250px' }} className='btn btn-success mb-2'>
                            Add to Cart   <FontAwesomeIcon icon={faShoppingCart} /> </button>
                    </div>

                </div>
            </Card>


        </div>



    );
};

export default Product;